import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoEvolucaoMensal, IndicacaoFiltros } from './indicacao.types';

export const getIndicacaoEvolucao = async (filtros?: IndicacaoFiltros) => {
	try {
		const response = await BaseClient.get<IndicacaoApiResponse<IndicacaoEvolucaoMensal[]>>(
			'v2/Indicacao/Evolucao',
			{
				params: {
					data_inicio: filtros?.data_inicio || undefined,
					data_fim: filtros?.data_fim || undefined,
					id_usuario: filtros?.id_usuario || undefined,
				},
			}
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoEvolucaoMensal[]>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
